/*Global*/
import logo from '../assets/Logo/23-coffee-transparent.png';

/*Home*/
import home1 from '../assets/Home/Home-1.jpg';
import home2 from '../assets/Home/Home-2.jpg';
import home3 from '../assets/Home/Home-3.jpg';

/*About*/
import about from '../assets/About/About-Image.jpg';

/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';

/*service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Gallery/2.jpg';

/*Team*/
import team1 from '../assets/Team/Team-7.png';
import team2 from '../assets/Team/Team-6.png';
import team3 from '../assets/Team/Team-3.jpg';
import team4 from '../assets/Team/Team-5.png';

/*Testimonials*/
import testimonial1 from '../assets/Testimonials/Pic-1.jpg';
import testimonial2 from '../assets/Testimonials/Pic-2.jpg';
import testimonial3 from '../assets/Testimonials/Pic-3.jpg';
import testimonial4 from '../assets/Testimonials/Pic-4.jpg';

/*Clients*/
import client1 from '../assets/Clients/Client-1.png';
import client2 from '../assets/Clients/Client-2.png';
import client3 from '../assets/Clients/Client-3.png';
import client4 from '../assets/Clients/Client-4.png';
import client5 from '../assets/Clients/Client-5.png';
import client6 from '../assets/Clients/Client-6.png';
import client7 from '../assets/Clients/Client-7.png';
import client8 from '../assets/Clients/Client-8.png';

/*Gallery*/
import coffee1 from '../assets/Gallery/Coffee/Latte.jpg';
import coffee2 from '../assets/Gallery/Coffee/Cappuccino.jpg';
import coffee3 from '../assets/Gallery/Coffee/Black-Coffee.jpg';
import drink1 from '../assets/Gallery/Hot-Drinks/Hot-Chocolate.jpg';
import drink2 from '../assets/Gallery/Hot-Drinks/Black-Tea.jpg';
import drink3 from '../assets/Gallery/Hot-Drinks/Earl-Grey.jpg';
import dessert1 from '../assets/Gallery/Desserts/Croissant.jpg';
import dessert2 from '../assets/Gallery/Desserts/Cupcake.jpg';
import dessert3 from '../assets/Gallery/Desserts/Doughnut.jpg';

/*Menu*/
import espresso1 from '../assets/Menu/Category-1/Item-1.jpg';
import espresso2 from '../assets/Menu/Category-1/Item-2.jpg';
import espresso3 from '../assets/Menu/Category-1/Item-3.jpg';
import espresso4 from '../assets/Menu/Category-1/Item-4.jpg';
import espresso5 from '../assets/Menu/Category-1/Item-5.jpg';
import espresso6 from '../assets/Menu/Category-1/Item-6.jpg';
import espresso7 from '../assets/Menu/Category-1/Item-7.jpg';
import espresso8 from '../assets/Menu/Category-1/Item-8.jpg';

import coldBrew1 from '../assets/Menu/Category-2/Item-1.jpg';
import coldBrew2 from '../assets/Menu/Category-2/Item-2.jpg';
import coldBrew3 from '../assets/Menu/Category-2/Item-3.jpg';
import coldBrew4 from '../assets/Menu/Category-2/Item-4.jpg';
import coldBrew5 from '../assets/Menu/Category-2/Item-5.jpg';
import coldBrew6 from '../assets/Menu/Category-2/Item-6.jpg';
import coldBrew7 from '../assets/Menu/Category-2/Item-7.jpg';
import coldBrew8 from '../assets/Menu/Category-2/Item-8.jpg';

import sweet1 from '../assets/Menu/Category-3/Item-1.jpg';
import sweet2 from '../assets/Menu/Category-3/Item-2.jpg';
import sweet3 from '../assets/Menu/Category-3/Item-3.jpg';
import sweet4 from '../assets/Menu/Category-3/Item-4.jpg';
import sweet5 from '../assets/Menu/Category-3/Item-5.jpg';
import sweet6 from '../assets/Menu/Category-3/Item-6.jpg';
import sweet7 from '../assets/Menu/Category-3/Item-7.jpg';
import sweet8 from '../assets/Menu/Category-3/Item-8.jpg';

/*Profile Pic*/
import profile from '../assets/Testimonials/Pic-1.jpg';

/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog1Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog1Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog1Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog1Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog2Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog2Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog2Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog2Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog3Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog3Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog3Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog3Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog4Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog4Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog4Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog4Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog5Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog5Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog5Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog5Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog6Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog6Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog6Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog6Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog7Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog7Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog7Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog7Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog8Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog8Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog8Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog8Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog9Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog9Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog9Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog9Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog10Gallery3 from '../assets/Blog/Blog-Gallery/3.jpg';
import blog10Gallery4 from '../assets/Blog/Blog-Gallery/4.jpg';
import blog10Gallery5 from '../assets/Blog/Blog-Gallery/5.jpg';
import blog10Gallery6 from '../assets/Blog/Blog-Gallery/6.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';


/*Shop*/
import bottledWater from '../assets/Shop/Products/Bottled-Water.png';
import coffeeSyrups from '../assets/Shop/Products/Coffee-Syrups.png';
import product1Gallery1 from '../assets/Shop/Products/1.jpg';
import product1Gallery2 from '../assets/Shop/Products/2.jpg';
import product1Gallery3 from '../assets/Shop/Products/3.jpg';
import product1Gallery4 from '../assets/Shop/Products/4.jpg';
import product1Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product1Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product2Gallery1 from '../assets/Shop/Products/2.jpg';
import product2Gallery2 from '../assets/Shop/Products/3.jpg';
import product2Gallery3 from '../assets/Shop/Products/4.jpg';
import product2Gallery4 from '../assets/Shop/Products/5.jpg';
import product2Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product2Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product3Gallery1 from '../assets/Shop/Products/3.jpg';
import product3Gallery2 from '../assets/Shop/Products/4.jpg';
import product3Gallery3 from '../assets/Shop/Products/5.jpg';
import product3Gallery4 from '../assets/Shop/Products/6.jpg';
import product3Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product3Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product4Gallery1 from '../assets/Shop/Products/4.jpg';
import product4Gallery2 from '../assets/Shop/Products/5.jpg';
import product4Gallery3 from '../assets/Shop/Products/6.jpg';
import product4Gallery4 from '../assets/Shop/Products/7.jpg';
import product4Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product4Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product5Gallery1 from '../assets/Shop/Products/5.jpg';
import product5Gallery2 from '../assets/Shop/Products/6.jpg';
import product5Gallery3 from '../assets/Shop/Products/7.jpg';
import product5Gallery4 from '../assets/Shop/Products/8.jpg';
import product5Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product5Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product6Gallery1 from '../assets/Shop/Products/6.jpg';
import product6Gallery2 from '../assets/Shop/Products/7.jpg';
import product6Gallery3 from '../assets/Shop/Products/8.jpg';
import product6Gallery4 from '../assets/Shop/Products/9.jpg';
import product6Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product6Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product7Gallery1 from '../assets/Shop/Products/7.jpg';
import product7Gallery2 from '../assets/Shop/Products/8.jpg';
import product7Gallery3 from '../assets/Shop/Products/9.jpg';
import product7Gallery4 from '../assets/Shop/Products/10.jpg';
import product7Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product7Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product8Gallery1 from '../assets/Shop/Products/8.jpg';
import product8Gallery2 from '../assets/Shop/Products/9.jpg';
import product8Gallery3 from '../assets/Shop/Products/10.jpg';
import product8Gallery4 from '../assets/Shop/Products/1.jpg';
import product8Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product8Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product9Gallery1 from '../assets/Shop/Products/9.jpg';
import product9Gallery2 from '../assets/Shop/Products/10.jpg';
import product9Gallery3 from '../assets/Shop/Products/1.jpg';
import product9Gallery4 from '../assets/Shop/Products/2.jpg';
import product9Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product9Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product10Gallery1 from '../assets/Shop/Products/10.jpg';
import product10Gallery2 from '../assets/Shop/Products/11.jpg';
import product10Gallery3 from '../assets/Shop/Products/12.jpg';
import product10Gallery4 from '../assets/Shop/Products/13.jpg';
import product10Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product10Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product11Gallery1 from '../assets/Shop/Products/11.jpg';
import product11Gallery2 from '../assets/Shop/Products/12.jpg';
import product11Gallery3 from '../assets/Shop/Products/13.jpg';
import product11Gallery4 from '../assets/Shop/Products/14.jpg';
import product11Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product11Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product12Gallery1 from '../assets/Shop/Products/12.jpg';
import product12Gallery2 from '../assets/Shop/Products/13.jpg';
import product12Gallery3 from '../assets/Shop/Products/14.jpg';
import product12Gallery4 from '../assets/Shop/Products/15.jpg';
import product12Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product12Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product13Gallery1 from '../assets/Shop/Products/13.jpg';
import product13Gallery2 from '../assets/Shop/Products/14.jpg';
import product13Gallery3 from '../assets/Shop/Products/15.jpg';
import product13Gallery4 from '../assets/Shop/Products/1.jpg';
import product13Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product13Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product14Gallery1 from '../assets/Shop/Products/14.jpg';
import product14Gallery2 from '../assets/Shop/Products/15.jpg';
import product14Gallery3 from '../assets/Shop/Products/1.jpg';
import product14Gallery4 from '../assets/Shop/Products/2.jpg';
import product14Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product14Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product15Gallery1 from '../assets/Shop/Products/15.jpg';
import product15Gallery2 from '../assets/Shop/Products/1.jpg';
import product15Gallery3 from '../assets/Shop/Products/2.jpg';
import product15Gallery4 from '../assets/Shop/Products/3.jpg';
import product15Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product15Review2 from '../assets/Shop/Reviews/Pic-2.jpg';



const Images = {

    /*Global*/
    logo,

    /*Home*/
    home1,
    home2,
    home3,

    /*About*/
    about,

    /*FAQs*/
    FAQs,

    /*Services*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*Team*/
    team1,
    team2,
    team3,
    team4,

    /*Testimonials*/
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,

    /*Clients*/
    client1,
    client2,
    client3,
    client4,
    client5,
    client6,
    client7,
    client8,

    /*Gallery*/
    coffee1,
    coffee2,
    coffee3,
    drink1,
    drink2,
    drink3,
    dessert1,
    dessert2,
    dessert3,

    /*Menu*/
    espresso1,
    espresso2,
    espresso3,
    espresso4,
    espresso5,
    espresso6,
    espresso7,
    espresso8,

    coldBrew1,
    coldBrew2,
    coldBrew3,
    coldBrew4,
    coldBrew5,
    coldBrew6,
    coldBrew7,
    coldBrew8,

    sweet1,
    sweet2,
    sweet3,
    sweet4,
    sweet5,
    sweet6,
    sweet7,
    sweet8,

    /*Profile Pic*/
    profile,

    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Gallery3,
    blog1Gallery4,
    blog1Gallery5,
    blog1Gallery6,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Gallery3,
    blog2Gallery4,
    blog2Gallery5,
    blog2Gallery6,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Gallery3,
    blog3Gallery4,
    blog3Gallery5,
    blog3Gallery6,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Gallery3,
    blog4Gallery4,
    blog4Gallery5,
    blog4Gallery6,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Gallery3,
    blog5Gallery4,
    blog5Gallery5,
    blog5Gallery6,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Gallery3,
    blog6Gallery4,
    blog6Gallery5,
    blog6Gallery6,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Gallery3,
    blog7Gallery4,
    blog7Gallery5,
    blog7Gallery6,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Gallery3,
    blog8Gallery4,
    blog8Gallery5,
    blog8Gallery6,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Gallery3,
    blog9Gallery4,
    blog9Gallery5,
    blog9Gallery6,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Gallery3,
    blog10Gallery4,
    blog10Gallery5,
    blog10Gallery6,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    /*Shop*/
    bottledWater,
    coffeeSyrups,
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Review1,
    product1Review2,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3,
    product2Gallery4,
    product2Review1,
    product2Review2,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3,
    product3Gallery4,
    product3Review1,
    product3Review2,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3,
    product4Gallery4,
    product4Review1,
    product4Review2,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3,
    product5Gallery4,
    product5Review1,
    product5Review2,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3,
    product6Gallery4,
    product6Review1,
    product6Review2,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3,
    product7Gallery4,
    product7Review1,
    product7Review2,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3,
    product8Gallery4,
    product8Review1,
    product8Review2,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3,
    product9Gallery4,
    product9Review1,
    product9Review2,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3,
    product10Gallery4,
    product10Review1,
    product10Review2,

    product11Gallery1,
    product11Gallery2,
    product11Gallery3,
    product11Gallery4,
    product11Review1,
    product11Review2,

    product12Gallery1,
    product12Gallery2,
    product12Gallery3,
    product12Gallery4,
    product12Review1,
    product12Review2,

    product13Gallery1,
    product13Gallery2,
    product13Gallery3,
    product13Gallery4,
    product13Review1,
    product13Review2,

    product14Gallery1,
    product14Gallery2,
    product14Gallery3,
    product14Gallery4,
    product14Review1,
    product14Review2,

    product15Gallery1,
    product15Gallery2,
    product15Gallery3,
    product15Gallery4,
    product15Review1,
    product15Review2,

};

export default Images;
